import React from 'react';
import { X } from 'lucide-react';

export const GuestSessionBanner = ({ onSave, onExit, profile = false }) => {
  const prefix = profile ? 'profile-guest' : 'guest';
  return (
    <div className={`guest-banner ${profile ? 'guest-banner-profile' : 'guest-banner-desktop'}`} data-testid={`${prefix}-banner`}>
      <span className="guest-banner-text" data-testid={`${prefix}-message`}>
        You're in a guest session — sign up to save your workspace permanently.
      </span>
      <div className="guest-banner-actions">
        <button className="guest-banner-signup-btn" onClick={onSave} data-testid={`${prefix}-save-btn`}>Save Workspace</button>
        <button className="guest-banner-exit-btn" onClick={onExit} data-testid={`${prefix}-exit-btn`}><X size={13} /> Exit</button>
      </div>
    </div>
  );
};